/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureSummarySortCriteria {
    getFixupPrototypeFunction() { return TagPostureSummarySortCriteria.fixupPrototype; }

    static newInstance(model: Partial<TagPostureSummarySortCriteria>): TagPostureSummarySortCriteria {
        let obj = Object.assign(new TagPostureSummarySortCriteria(), model);
        TagPostureSummarySortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureSummarySortCriteria>): TagPostureSummarySortCriteria {
        if (!model) return null;
        return TagPostureSummarySortCriteria.newInstance(<TagPostureSummarySortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureSummarySortCriteria) {
        if (!obj) return;

        models.TagPostureSummarySortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureSummarySortCriteria): boolean {
        Object.setPrototypeOf(obj, TagPostureSummarySortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.TagPostureSummarySortColumn;

    ascending: boolean;

}
